import { StudioSystemType } from 'types/global'
import { getSystemRoofType } from '../../compatibility'
import { NOVA_LABELS } from './novaLabels'

// Always returns true — this hook is used to display an info message for tile roofs,
// not to block compatibility. The compatibility.tsx caller treats false as a blocker,
// but this function never returns false.
export function validateNovaCompatibility(system: StudioSystemType): boolean {
  const mountingName = system?.mounting
  if (mountingName !== 'nova') return true

  const infoKey = `${mountingName.toUpperCase()}_TILE_INFO`
  window.WorkspaceHelper.removeProjectErrorFromReduxStore(infoKey, system.uuid, 'plugin')

  const roofType = getSystemRoofType()
  if (roofType === 'Tile Clay' || roofType === 'Tile Concrete') {
    window.WorkspaceHelper.addProjectErrorToReduxStore({
      message: window.translate(
        'Depending on the tile, you may have to shave/grind part of the tile to make the tile attachment fit.'
      ),
      key: infoKey,
      severity: 'info',
      systemId: system.uuid,
      source: 'plugin',
      category: 'mounting',
      options: {},
    })
  }

  const orientationKey = 'NOVA_MIXED_ORIENTATION'
  window.WorkspaceHelper.removeProjectErrorFromReduxStore(orientationKey, system.uuid, 'plugin')

  const isTileRoof = roofType === 'Tile Clay' || roofType === 'Tile Concrete'
  const grids = system.moduleGrids?.() ?? []
  if (isTileRoof && grids.length >= 2) {
    const orientations = grids.map((mg: any) => mg.moduleLayout())
    const hasMixed = orientations.some((o: string) => o !== orientations[0])
    if (hasMixed) {
      window.WorkspaceHelper.addProjectErrorToReduxStore({
        message: window.translate(
          'NOVA mounting requires all panel groups to have the same orientation on tile roofs. Orientations will be synchronized automatically.'
        ),
        key: orientationKey,
        severity: 'warning',
        systemId: system.uuid,
        source: 'plugin',
        category: 'mounting',
        options: {},
      })
    }
  }

  const railInfoKey = 'NOVA_2400RAIL_INFO'
  window.WorkspaceHelper.removeProjectErrorFromReduxStore(railInfoKey, system.uuid, 'plugin')

  const novaJson = system.integration_json?.nova
  if (Number(novaJson?.railLength) === 2400 && novaJson?.componentColour === 'Black') {
    window.WorkspaceHelper.addProjectErrorToReduxStore({
      message: window.translate(NOVA_LABELS.componentColour2400Tooltip),
      key: railInfoKey,
      severity: 'info',
      systemId: system.uuid,
      source: 'plugin',
      category: 'mounting',
      options: {},
    })
  }

  return true
}
